import React from 'react';
import { CycleLegs } from 'views/availability/CycleLegs';
import { DocLink, DocPages } from 'components/Help/';
import CycleFormInput from './input';

const config = {
  init: {
    active: true
  },
  // List Table
  list: {
    // Table Columns
    columns: [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true,
        defaultSortOrder: 'ascend'
      }
    ],
    // Deleting
    confirmMessage: item => (
      <div>
        <p>
          Are you sure you wish to delete the cycle
          {' '}
          <b>{item.name}</b>
          ?
        </p>
        <p>
          This action cannot be undone.
        </p>
      </div>
    ),
    // Filtering
    sorter: {
      field: 'name',
      order: 'ascend'
    },
    filters: {},
    customFilters: {
      name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['name'],
        searchValue: ''
      }
    },
    // General
    title: <DocLink page={DocPages.availabilityCycle}>Cycles</DocLink>
  },
  // Detail Screen
  detail: {
    // General
    emptyMessage: 'Please select a Cycle',
    title: 'Cycle',
    tabItems: [
      {
        key: 0,
        title: 'Details',
        component: props => (
          <CycleFormInput
            {...props}
            title="Cycle"
          />
        )
      },
      {
        key: 1,
        title: 'Legs',
        component: props => (
          <CycleLegs
            {...props}
            title="Legs"
          />
        )
      }
    ]
  }
};

export default config;
